import React from 'react';
import { useTranslation } from 'react-i18next';
import { Roadside } from '/src/images/home';

const AboutUs = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.future' });

	return (
		<section id="about-us">
			<div>
				<h1>{t('an-eye-towards-the-future')}</h1>

				<section>
					<aside>
						<h4>{t('about-us')}</h4>

						<p>{t('our-identity-is-simple')}</p>

						{/* <button>{t('get-to-know-driver')}</button> */}
					</aside>

					<aside>
						<img src={Roadside} alt={t('get-to-know-driver')} />
					</aside>
				</section>
			</div>
		</section>
	);
};

export default AboutUs;
